<!--==================================================
    component name  : 空箱查詢 - 彈出視窗 / 收費查詢
    author          : Samma
    last update     : 2020-05-08
    use description : 
==================================================-->
<template>
  <div class="tab-inner" id="tab03">
    <div
      v-if="is_show_content"
      class="title"
      v-html="
        $tc('message.qs_fee_desc', fee_desc_hours, { hours: fee_desc_hours })
      "
    ></div>
    <!--費率表-->
    <table v-if="is_show_content">
      <tr>
        <th v-if="is_show_content && prices && prices.length > 1">
          {{ $t('message.qs_fee_head') }}
        </th>
        <th v-for="(fee, fee_idx) in prices_title['fee']" v-bind:key="fee_idx">
          <span v-if="fee.size">{{
            $t('message.qs_locker_size_' + fee.size)
          }}</span>
        </th>
      </tr>
      <tr v-for="(price, price_idx) in prices" v-bind:key="price_idx">
        <td v-if="is_show_content && prices && prices.length > 1">
          {{
            $t('message.qs_fee_stage' + (price_idx + 1), {
              start_hours: price['min_hour'],
              end_hours: price['max_hour'],
            })
          }}
        </td>

        <td v-for="(fee, fee_idx) in price['fee']" v-bind:key="fee_idx">
          {{
            $tc('message.qs_fee_rate', fee['unit_hour'], {
              fee: fee['unit_fee'],
              hours: fee['unit_hour'],
            })
          }}
        </td>
      </tr>
    </table>

    <!--費用計算說明-->
    <div v-if="is_show_content && prices && prices.length > 1" class="textbox2">
      <b>{{ $t('message.qs_sample_title') }}</b>
      <p>
        <b>{{ $t('message.qs_sample_desc') }}</b>
      </p>
      <br />
      <p v-html="$t('message.qs_sample_content1')"></p>
      <br />
      <p v-html="$t('message.qs_sample_content2')"></p>
      <br />
      <p v-html="$t('message.qs_sample_content3')"></p>
      <br />
      <p v-html="$t('message.qs_sample_content4')"></p>
    </div>
    <div v-else-if="is_show_content" class="textbox2">
      <b>{{ $t('message.qs_sample_title') }}</b>
      <p>
        <b>{{ $t('message.qs_sample2_desc') }}</b>
      </p>
      <br />
      <p v-html="$t('message.qs_sample2_content1')"></p>
      <br />
    </div>

    <!--久置日期提示-->
    <div v-if="is_show_content" class="textbox">
      <p>
        {{ $t('message.qs_save_limit_desc1') }}<b>{{ over_day }} </b>
      </p>
      <p
        v-html="
          $t('message.qs_save_limit_desc2', {
            short_days: over_day,
            limit_days: lonest_day,
          })
        "
      ></p>
    </div>

    <!--支付方式-->
    <div v-if="is_show_content" class="title">
      {{ $t('message.qs_payment_method') }}
      <div class="imgpay">
        <!--現金-->
        <div class="paytitle" v-if="payment_way['cash']">
          {{ $t('message.qs_payment_cash') }}
          <div class="paybox">
            <div class="box1">
              <img
                src="../assets/images/cash_100.svg"
                alt="100"
                title="NT$100"
              />
            </div>
            <div class="box2">
              <img src="../assets/images/cash_50.svg" alt="50" title="NT$50" />
            </div>
            <div class="box3">
              <img src="../assets/images/cash_10.svg" alt="10" title="NT$10" />
            </div>
          </div>
        </div>
        <!--電子票證-->
        <div class="paytitle" v-if="payment_way['epayment']">
          {{ $t('message.qs_payment_ecard') }}
          <div class="paybox">
            <div class="box1">
              <img
                src="../assets/images/easycard.svg"
                alt="悠遊卡"
                title="悠遊卡 EasyCard"
              />
            </div>
            <div class="box1">
              <img
                src="../assets/images/ipass.svg"
                alt="ipass"
                title="一卡通 IPASS"
              />
            </div>
            <div class="box1">
              <img
                src="../assets/images/icash.svg"
                alt="icash"
                title="愛金卡 icash"
              />
            </div>
            <!--div class="box1"><img src="../assets/images/happycash.svg" alt="happycash" title="有錢卡 happycash"/></div-->
          </div>
        </div>
        <!--信用卡-->
        <div class="paytitle" v-if="payment_way['ccpayment']">
          {{ $t('message.qs_payment_ccard') }}
          <div class="paybox">
            <div class="box1">
              <img src="../assets/images/visa.svg" alt="visa" title="VISA" />
            </div>
            <div class="box1">
              <img
                src="../assets/images/mastercard.svg"
                alt="mastercard"
                title="mastercard"
              />
            </div>
            <div class="box1">
              <img src="../assets/images/jcb.svg" alt="jcb" title="JCB" />
            </div>
            <div class="box1">
              <img
                src="../assets/images/american.svg"
                alt="american"
                title="American Express"
              />
            </div>
            <div class="box1">
              <img
                src="../assets/images/appleypay.svg"
                alt="appleypay"
                title="Appley Pay"
              />
            </div>
            <div class="box1">
              <img
                src="../assets/images/googlepay.svg"
                alt="googlepay"
                title="Google Pay"
              />
            </div>
            <div class="box1">
              <img
                src="../assets/images/samsungpay.svg"
                alt="samsungpay"
                title="Samsung Pay"
              />
            </div>
          </div>
        </div>
        <!--其它-->
        <div
          class="paytitle"
          v-if="payment_way['linepay'] || payment_way['jkopay']"
        >
          {{ $t('message.qs_payment_other') }}
          <div class="paybox">
            <div class="box4" v-if="payment_way['linepay']">
              <img
                src="../assets/images/linepay.svg"
                alt="linepay"
                title="LINE Pay"
              />
            </div>
            <div class="box1" v-if="payment_way['jkopay']">
              <img
                src="../assets/images/jkopay.svg"
                alt="街口"
                title="街口支付 JKOPAY"
              />
            </div>
            <div class="box1" v-if="payment_way['pluspay']">
              <img
                src="../assets/images/pluspay.svg"
                alt="全盈"
                title="全盈+PAY PLUSPAY"
              />
            </div>
            <div class="box1" v-if="payment_way['uupay']">
              <img
                src="../assets/images/uupay.svg"
                alt="悠遊付"
                title="悠遊付 EasyWallet"
              />
            </div>
            <div class="box1" v-if="payment_way['pxpayplus']">
              <img
                src="../assets/images/pxpay.svg"
                alt="全支付"
                title="全支付 PXPAY PLUS"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--收費試算-->
    <div v-if="is_show_content" class="title" :class="{ show: result_open }">
      {{ $t('message.qs_calcumation_title') }}
      <div class="optext">{{ $t('message.qs_pick_size') }}</div>
      <div class="select">
        <select id="fee_size" v-model="fee_size">
          <option
            v-for="(locker, locker_idx) in lockers_type"
            v-bind:key="locker_idx"
            v-bind:value="locker.size"
          >
            {{ $t('message.qs_locker_size_' + locker.size) }}
          </option>
        </select>
      </div>
      <div class="optext">{{ $t('message.qs_select_deposit_datetime') }}</div>
      <div class="row">
        <!--放入日期-->
        <div class="col-xl-4 col-md-4">
          <div class="datebox">
            <label>
              <input
                type="text"
                id="fee_deposit_date"
                class="dateselect"
                required="required"
                readonly
              />
              <i class="far fa-calendar-alt"></i>
            </label>
          </div>
        </div>
        <!--放入時間-->
        <div class="col-xl-3 col-md-3">
          <div class="select2">
            <select
              id="fee_deposit_hour"
              v-model="fee_deposit_hour"
              onfocus="this.size=8;"
              onblur="this.size=1;"
              onchange="this.size=1; this.blur();"
            >
              <option
                v-for="(hour, hour_idx) in list_hours"
                v-bind:key="hour_idx"
                v-bind:value="hour"
              >
                {{ hour }}
              </option>
            </select>
          </div>
        </div>
        <span>:</span>
        <div class="col-xl-3 col-md-3">
          <div class="select2">
            <select
              id="fee_deposit_min"
              v-model="fee_deposit_min"
              onfocus="this.size=8;"
              onblur="this.size=1;"
              onchange="this.size=1; this.blur();"
            >
              <option
                v-for="(min, min_idx) in list_minutes"
                v-bind:key="min_idx"
                v-bind:value="min"
              >
                {{ min }}
              </option>
            </select>
          </div>
        </div>
        <!--放入日期 : 錯誤訊息-->
        <div class="col-xl-12">
          <div class="error" :class="{ show: deposit_datetime_error }">
            <div class="box">
              <i class="fas fa-times-circle"></i>
              <div class="redtext">
                {{ $t('message.' + deposit_datetime_error_label) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="optext">{{ $t('message.qs_select_takeout_datetime') }}</div>
      <div class="row">
        <!--取出日期-->
        <div class="col-xl-4 col-md-4">
          <div class="datebox">
            <label>
              <input
                type="text"
                id="fee_takeout_date"
                class="dateselect"
                required="required"
                readonly
              />
              <i class="far fa-calendar-alt"></i>
            </label>
          </div>
        </div>
        <!--取出時間-->
        <div class="col-xl-3 col-md-3">
          <div class="select2">
            <select
              id="fee_takeout_hour"
              v-model="fee_takeout_hour"
              onfocus="this.size=8;"
              onblur="this.size=1;"
              onchange="this.size=1; this.blur();"
            >
              請選擇小時
              <option
                v-for="(hour, hour_idx) in list_hours"
                v-bind:key="hour_idx"
                v-bind:value="hour"
              >
                {{ hour }}
              </option>
            </select>
          </div>
        </div>
        <span>:</span>
        <div class="col-xl-3 col-md-3">
          <div class="select2">
            <select
              id="fee_takeout_min"
              v-model="fee_takeout_min"
              onfocus="this.size=8;"
              onblur="this.size=1;"
              onchange="this.size=1; this.blur();"
            >
              請選擇分鐘
              <option
                v-for="(min, min_idx) in list_minutes"
                v-bind:key="min_idx"
                v-bind:value="min"
              >
                {{ min }}
              </option>
            </select>
          </div>
        </div>
        <!--取出日期 : 錯誤訊息-->
        <div class="col-xl-12">
          <div class="error" :class="{ show: takeout_datetime_error }">
            <div class="box">
              <i class="fas fa-times-circle"></i>
              <div class="redtext">
                {{ $t('message.' + takeout_datetime_error_label) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btnbox">
        <div class="button" @click="vCalFee()">
          {{ $t('message.qs_start_calcumation') }}
        </div>
      </div>
    </div>
    <!--試算結果-->
    <div class="title2" :class="{ show: result_open }">
      {{ $t('message.qs_result_title') }}
      <div class="result">
        {{ $t('message.qs_size_title') }}
        <span v-if="cal_result['size']">{{
          $t('message.qs_locker_size_' + cal_result['size'])
        }}</span>
      </div>
      <div class="result">
        {{ $t('message.qs_deposit_date') }}
        <span>{{ cal_result['deposit_datetime'] }}</span>
      </div>
      <div class="result">
        {{ $t('message.qs_takeout_date') }}
        <span>{{ cal_result['takeout_datetime'] }}</span>
      </div>
      <div class="result">
        {{ $t('message.qs_rental_hours') }}
        <span>{{
          $t('message.qs_fee_hours', { hours: cal_result['fee_hour'] })
        }}</span>
      </div>
      <div class="result2">
        {{ $t('message.qs_rental_fee') }}
        <span>{{
          $t('message.qs_fee_dollar', { dollars: cal_result['fee'] })
        }}</span>
      </div>
      <div class="btnbox">
        <div class="button" @click="result_open = !result_open">
          {{ $t('message.qs_recalcumation') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import Public from '@/scripts/public';

export default {
  name: 'QsTab03',
  data: function () {
    return {
      cal_fee_api: Public.appGetAPIURL('cal-fee'),
      site_no: '',
      //是否顯示整個 tab 內容
      is_show_content: true,
      //最小租用時數
      fee_desc_hours: '--',
      //費率表 (初始化)
      init_prices: [
        {
          min_hour: 1,
          max_hour: 24,
          fee: [
            {
              size: 'S',
              unit_fee: '--',
              unit_hour: '--',
            },
            {
              size: 'L',
              unit_fee: '--',
              unit_hour: '--',
            },
            {
              size: 'M',
              unit_fee: '--',
              unit_hour: '--',
            },
          ],
        },
        {
          min_hour: 25,
          max_hour: 48,
          fee: [
            {
              size: 'S',
              unit_fee: '--',
              unit_hour: '--',
            },
            {
              size: 'L',
              unit_fee: '--',
              unit_hour: '--',
            },
            {
              size: 'M',
              unit_fee: '--',
              unit_hour: '--',
            },
          ],
        },
        {
          min_hour: 49,
          max_hour: 144,
          fee: [
            {
              size: 'S',
              unit_fee: '--',
              unit_hour: '--',
            },
            {
              size: 'L',
              unit_fee: '--',
              unit_hour: '--',
            },
            {
              size: 'M',
              unit_fee: '--',
              unit_hour: '--',
            },
          ],
        },
      ],
      //費率表 (UI顯示)
      prices: null,
      //久置日期
      over_day: '--',
      //保留日期
      lonest_day: '--',
      //支付方式
      payment_way: {
        cash: false,
        epayment: false,
        ccpayment: false,
        linepay: false,
        jkopay: false,
        pluspay: false,
        uupay: false,
        pxpayplus: false,
      },
      //費用試算條件 - 副櫃尺寸
      lockers_type: [
        {
          size: 'S',
          total: 0,
          empty: 0,
        },
        {
          size: 'L',
          total: 0,
          empty: 0,
        },
        {
          size: 'M',
          total: 0,
          empty: 0,
        },
      ],
      //費用試算條件 - 小時
      list_hours: [],
      //費用試算條件 - 分鐘
      list_minutes: [],
      //費用試算條件 - 使用者操作結果
      init_fee_deposit_date: '',
      init_fee_takeout_date: '',
      fee_size: '',
      fee_deposit_hour: '',
      fee_deposit_min: '',
      deposit_datetime_error: false,
      deposit_datetime_error_label: 'qs_deposit_datetime_err1',
      fee_takeout_hour: '',
      fee_takeout_min: '',
      takeout_datetime_error: false,
      takeout_datetime_error_label: 'qs_takeout_datetime_err1',
      //是否顯示試算費用結果
      result_open: false,
      //費用試算結果
      cal_result: {
        size: '',
        deposit_datetime: '',
        takeout_datetime: '',
        fee_hour: null,
        fee: null,
      },
      //是否鎖定費用計算鈕
      is_lock_calcumation: false,
    };
  },
  computed: {
    //費率表(title)
    prices_title: function () {
      return this.prices && this.prices.length > 0 ? this.prices[0] : [];
    },
  },
  mounted: function () {
    var i = 0;
    //設定小時
    for (i = 0; i < 24; i++) {
      this.list_hours.push(Public.pbZeroPadding(i, 2));
    }
    //設定分鐘
    for (i = 0; i < 60; i++) {
      this.list_minutes.push(Public.pbZeroPadding(i, 2));
    }
  },
  updated: function () {
    var ref = this;
    this.$nextTick(function () {
      require('@/assets/framework/bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js');
      require('@/assets/framework/bootstrap-datepicker/dist/locales/bootstrap-datepicker.zh-TW.min.js');
      require('@/assets/framework/bootstrap-datepicker/dist/locales/bootstrap-datepicker.en-US.min.js');
      //日期選擇器，跟著多國語系一起切換
      $('.dateselect').datepicker('destroy');
      $('.dateselect').datepicker({
        format: 'yyyy-mm-dd',
        autoclose: true,
        locale: ref.$parent.$i18n.locale,
        language: ref.$parent.$i18n.locale,
      });
      $('#fee_deposit_date').datepicker(
        'setDate',
        $('#fee_deposit_date').val() && $('#fee_deposit_date').val().length > 0
          ? $('#fee_deposit_date').val()
          : this.init_fee_deposit_date
      );
      $('#fee_takeout_date').datepicker(
        'setDate',
        $('#fee_takeout_date').val() && $('#fee_takeout_date').val().length > 0
          ? $('#fee_takeout_date').val()
          : this.init_fee_takeout_date
      );
    });
  },
  methods: {
    vInitUIStatus: function () {
      //預設副櫃尺寸為第1個選項
      this.fee_size = this.lockers_type[0]['size'];
      //存入日期與時間，預設為當下
      var str_deposit_datetime = Public.pbGetCurrentDateTimeNoSec('-', ':');
      var deposit_datetime = str_deposit_datetime.split(' ');
      var deposit_times = deposit_datetime[1].split(':');
      this.init_fee_deposit_date = deposit_datetime[0];
      $('#fee_deposit_date').val(deposit_datetime[0]);
      this.fee_deposit_hour = deposit_times[0];
      this.fee_deposit_min = deposit_times[1];
      //取出日期與時間，預設為 3 小時後 ( safari 無法識別 yyyy-mm-dd，只能 yyyy/mm/dd )
      var takeout_datetime = new Date(
        str_deposit_datetime.replaceAll('-', '/')
      );
      takeout_datetime.setHours(takeout_datetime.getHours() + 3);
      var str_takeout_datetime = Public.pbGetSpecifiedDateTimeNoSec(
        takeout_datetime,
        '-',
        ':'
      );
      var takeout_datetimes = str_takeout_datetime.split(' ');
      var takeout_times = takeout_datetimes[1].split(':');
      this.init_fee_takeout_date = takeout_datetimes[0];
      $('#fee_takeout_date').val(takeout_datetimes[0]);
      this.fee_takeout_hour = takeout_times[0];
      this.fee_takeout_min = takeout_times[1];
      this.vInitCalFeeResult();
      this.result_open = false;
      this.is_lock_calcumation = false;
      this.deposit_datetime_error = false;
      this.takeout_datetime_error = false;
      this.deposit_datetime_error_label = 'qs_deposit_datetime_err1';
      this.takeout_datetime_error_label = 'qs_takeout_datetime_err1';
    },
    vInitCalFeeResult: function () {
      this.vShowContent(false);
      this.site_no = '';
      this.fee_desc_hours = '--';
      this.prices = this.init_prices;
      this.over_day = '--';
      this.lonest_day = '--';
      this.cal_result = {
        size: '',
        deposit_datetime: '',
        takeout_datetime: '',
        fee_hour: null,
        fee: null,
      };
    },
    vShowContent: function (is_show) {
      this.is_show_content = is_show;
      //如果試算結果為開啟
      if (this.is_show_content && this.result_open) {
        this.vCalFee();
      }
    },
    vCheckNoContent: function () {
      return this.fee_desc_hours === '--';
    },
    vLoadSiteNo: function (data) {
      this.site_no = data;
    },
    vLoadFeeDescHours: function (data) {
      this.fee_desc_hours = data;
    },
    vLoadPrices: function (data) {
      this.prices = data;
    },
    vLoadOverDay: function (data) {
      this.over_day = data;
    },
    vLoadLonestDay: function (data) {
      this.lonest_day = data;
    },
    vLoadPaymentWay: function (data) {
      if (data) {
        this.payment_way = {
          cash: data['cash'] ? data['cash'] : false,
          epayment: data['epayment'] ? data['epayment'] : false,
          ccpayment: data['ccpayment'] ? data['ccpayment'] : false,
          linepay: data['linepay'] ? data['linepay'] : false,
          jkopay: data['jkopay'] ? data['jkopay'] : false,
          pluspay: data['pluspay'] ? data['pluspay'] : false,
          uupay: data['uupay'] ? data['uupay'] : false,
          pxpayplus: data['pxpayplus'] ? data['pxpayplus'] : false,
        };
      }
    },
    vLoadLockersType: function (data) {
      this.lockers_type = data;
    },
    vCalFee: function () {
      this.deposit_datetime_error = false;
      this.takeout_datetime_error = false;
      //鎖住試算鈕，避免重複點擊運算
      if (this.is_lock_calcumation) {
        return;
      } else {
        this.is_lock_calcumation = true;
      }
      //選擇尺寸
      var fee_size = this.fee_size;
      //置換成後台理解的代碼
      if (fee_size == 'S') {
        fee_size = 'M';
      } else if (fee_size == 'M') {
        fee_size = 'S';
      }
      //存入日期 & 時間
      var deposit_date = $('#fee_deposit_date').val().replaceAll('-', '');
      var deposit_hour = this.fee_deposit_hour;
      var deposit_min = this.fee_deposit_min;
      //取出日期 & 時間
      var takeout_date = $('#fee_takeout_date').val().replaceAll('-', '');
      var takeout_hour = this.fee_takeout_hour;
      var takeout_min = this.fee_takeout_min;

      //需對試算條件進行邏輯合理性判斷
      if (!deposit_date || deposit_date.length < 8) {
        this.deposit_datetime_error_label = 'qs_deposit_datetime_err1';
        this.deposit_datetime_error = true;
        this.is_lock_calcumation = false;
        return;
      }
      if (!takeout_date || takeout_date.length < 8) {
        this.takeout_datetime_error_label = 'qs_takeout_datetime_err1';
        this.takeout_datetime_error = true;
        this.is_lock_calcumation = false;
        return;
      }
      var str_deposit_datetime =
        $('#fee_deposit_date').val() +
        ' ' +
        this.fee_deposit_hour +
        ':' +
        this.fee_deposit_min;
      var deposit_datetime = new Date(
        str_deposit_datetime.replaceAll('-', '/')
      );
      var str_takeout_datetime =
        $('#fee_takeout_date').val() +
        ' ' +
        this.fee_takeout_hour +
        ':' +
        this.fee_takeout_min;
      var takeout_datetime = new Date(
        str_takeout_datetime.replaceAll('-', '/')
      );
      if (deposit_datetime > takeout_datetime) {
        this.deposit_datetime_error_label = 'qs_deposit_datetime_err2';
        this.deposit_datetime_error = true;
        this.is_lock_calcumation = false;
        return;
      }

      //先行指定部份已知內容的試算結果
      this.cal_result = {
        size: this.fee_size,
        deposit_datetime: str_deposit_datetime,
        takeout_datetime: str_takeout_datetime,
        fee_hour: '--',
        fee: '--',
      };

      //傳送到後台做運算
      var query_path =
        this.site_no +
        '/' +
        fee_size +
        '/' +
        deposit_date +
        deposit_hour +
        deposit_min +
        '/' +
        takeout_date +
        takeout_hour +
        takeout_min;
      this.vLoadCalFeeResult(query_path);

      //切換到計算結果
      this.result_open = true;
    },
    //取得試算結果
    vLoadCalFeeResult: function (query_path) {
      var ref = this;
      var url = this.cal_fee_api + '/' + query_path;

      if (!url || url.length <= 0) {
        return;
      }

      // 從 chaches 取得
      Public.appGetOWLockerDataFromCache(url).then((data) => {
        ref.vRenderCalFeeResult(data);
      });

      // 從網路取得
      Public.appGetOWLockerDataFromNetwork(url).then((data) => {
        ref.vRenderCalFeeResult(data);
      });
    },
    vRenderCalFeeResult: function (cal_result) {
      this.is_lock_calcumation = false;
      //尺寸代碼依前端需求置換
      if (cal_result && cal_result['size']) {
        if (cal_result['size'] == 'S') {
          cal_result['size'] = 'M';
        } else if (cal_result['size'] == 'M') {
          cal_result['size'] = 'S';
        }
      }
      //比對回傳的試算結果與前端正在等待的計算結果一致時，帶入試算結果
      if (
        cal_result &&
        this.cal_result['size'] == cal_result['size'] &&
        this.cal_result['deposit_datetime'] == cal_result['start_time'] &&
        this.cal_result['takeout_datetime'] == cal_result['end_time']
      ) {
        this.cal_result['fee_hour'] = cal_result['fee_hour'];
        this.cal_result['fee'] = cal_result['fee'];
      }
    },
  },
};
</script>
